import React from "react";

const ToastWarnigIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
    <path
      d='M13.0661 11.7031L7.37857 1.85938C7.2938 1.71309 7.14751 1.64062 6.99986 1.64062C6.8522 1.64062 6.70455 1.71309 6.62115 1.85938L0.933647 11.7031C0.765483 11.9957 0.97603 12.3594 1.31236 12.3594H12.6874C13.0237 12.3594 13.2342 11.9957 13.0661 11.7031ZM6.56236 5.6875C6.56236 5.62734 6.61158 5.57813 6.67173 5.57813H7.32798C7.38814 5.57813 7.43736 5.62734 7.43736 5.6875V8.20313C7.43736 8.26328 7.38814 8.3125 7.32798 8.3125H6.67173C6.61158 8.3125 6.56236 8.26328 6.56236 8.20313V5.6875ZM6.99986 10.5C6.82813 10.4965 6.66462 10.4258 6.54441 10.3031C6.4242 10.1804 6.35687 10.0155 6.35687 9.84375C6.35687 9.67199 6.4242 9.50706 6.54441 9.38438C6.66462 9.26169 6.82813 9.19101 6.99986 9.1875C7.17159 9.19101 7.3351 9.26169 7.45531 9.38438C7.57552 9.50706 7.64285 9.67199 7.64285 9.84375C7.64285 10.0155 7.57552 10.1804 7.45531 10.3031C7.3351 10.4258 7.17159 10.4965 6.99986 10.5Z'
      fill='black'
      fillOpacity='0.7'
    />
  </svg>
);

export default ToastWarnigIcon;
